import { useEffect, useRef, useState, useContext, useLayoutEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { jwtDecode } from 'jwt-decode';
import { useUpdateRNotes } from '../Common/CommonHooks';
import { isLogonHigh } from './LoginHooks';
import { MaxOnePopupWindow, getSiteCoreImagePath } from '../Common/home-common';
import { GlobalContext } from '../../contexts/GlobalContext';
import { useLogoutBoxQuery } from '../Home/Data/SitecoreDataHooks';
import generalImg from '../../info/Include/images/betslip_default_card.svg';
import card_black_img from '../../info/Include/images/card_black.png';
import card_gold_img from '../../info/Include/images/card_gold.png';
import card_red_img from '../../info/Include/images/card_red.png';
import card_sliver_img from '../../info/Include/images/card_sliver.png';
import card_yellow_img from '../../info/Include/images/card_yellow.png';
import MonyIconW from '../../info/Include/images/mony-iconW1.svg';
import MonyIconS from '../../info/Include/images/mony-iconS.svg';
import qrcodeLogo from '../../info/Include/images/hkjcpriority_qrcode_logo.svg';
import { ReactComponent as RefIcon } from '../../info/Include/images/hkjcpriority_refresh.svg';
import { ReactComponent as GenFailIcon } from '../../info/Include/images/hkjcpriority_fail.svg';
import { Cookies } from '../Common/CookieHelper';
import { glassboxCustomEvent } from '../Common/utils/glassbox';
import { getPCardBalance_IB } from './BetSlipIBAPI';
import { textFormatAmountFn } from '../Common/GlobalFunc';
import { useAdobeLaunch } from '../Common/utils/adobeLaunch';
import JSCookies from "js-cookie";
import { QRCodeSVG } from 'qrcode.react';
import { Loading } from '../Common/ui-components';

const WINSBalance = ({ setShowWINSBalance, showWINSBalance }) => {
    const { t } = useTranslation();
    const WinsBalanceRef = useRef();
    const pCardSpendableVal = !['undefined', 'null', undefined, null].includes(sessionStorage.getItem('pCardSpendableVal')) ? sessionStorage.getItem('pCardSpendableVal') : '---';
    const pCardPDollar = !['undefined', 'null', undefined, null].includes(sessionStorage.getItem('pCardPDollar')) ? sessionStorage.getItem('pCardPDollar') : '---';
    const [qrCodeValue, setQRCodeValue] = useState(!['undefined', 'null', undefined, null, ''].includes(sessionStorage.getItem('pCardQrCode')) ? sessionStorage.getItem('pCardQrCode') : '');
    const [qrCodeGenerateFailed, setQRCodeGenerateFailed] = useState(['undefined', 'null', undefined, null, ''].includes(sessionStorage.getItem('pCardQrCode')));
    const [targetCount, setTargetCount] = useState(window.globalConfig.QRCodeRefreshSeconds);
    const [countdown, setCountdown] = useState(0);
    const endTimestampRef = useRef(null);

    const refreshQRCode = async () => {
        setQRCodeValue('');
        setQRCodeGenerateFailed(false);
        setCountdown(0); 
        endTimestampRef.current = null;

        const result = await getPCardBalance_IB();
        
        if (result.success && !['undefined', 'null', undefined, null].includes(sessionStorage.getItem('pCardQrCode'))) {
            setQRCodeValue(sessionStorage.getItem('pCardQrCode'));
            endTimestampRef.current = Date.now() + targetCount * 1000;
            setCountdown(targetCount);
        } else {
            setQRCodeGenerateFailed(true);
        }
    };
    useEffect(() => {
        if (qrCodeValue && !qrCodeGenerateFailed && !endTimestampRef.current) {
            endTimestampRef.current = Date.now() + targetCount * 1000;
            setCountdown(targetCount);
        }
    }, []);

    useEffect(() => {
        let interval;

        if (!qrCodeGenerateFailed && endTimestampRef.current) {
            interval = setInterval(() => {
                const now = Date.now();
                const remaining = Math.max(0, Math.ceil((endTimestampRef.current - now) / 1000));
                
                setCountdown(remaining);

                if (remaining <= 0) {
                    clearInterval(interval);
                    refreshQRCode();
                }
            }, 1000);
        }
    
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [qrCodeGenerateFailed, qrCodeValue]); 

    useEffect(() => {
        const close = (e) => {
            if (
                WinsBalanceRef.current &&
                e.target !== WinsBalanceRef.current &&
                !WinsBalanceRef.current.contains(e.target) &&
                e.target.className !== 'betslip-pcard-img'
            ) {
                setShowWINSBalance(false);
            }
        };
        document.addEventListener('click', close);
        return () => {
            document.removeEventListener('click', close);
        };
    }, []);
    useLayoutEffect(() => {
        function handleResize() {
            const divBetSlipNormal = document.getElementById('divBetSlipNormal');
            if (
                WinsBalanceRef.current &&
                divBetSlipNormal.offsetWidth &&
                WinsBalanceRef.current.offsetWidth > divBetSlipNormal.offsetWidth - 24
            ) {
                WinsBalanceRef.current.style.left =
                    '-' + (WinsBalanceRef.current.offsetWidth - divBetSlipNormal.offsetWidth + 24) + 'px';
                const winsBalanceBefore = document.getElementById('wins-balance-before');
                winsBalanceBefore.style.left =
                    WinsBalanceRef.current.offsetWidth - divBetSlipNormal.offsetWidth + 24 + 12 + 'px';
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        }

    },[])
    return <div ref={WinsBalanceRef} className={`wins-balance ${sessionStorage.getItem('enableEwinLP') === '1' ? 'enable' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div id="wins-balance-before" className="before"></div>
        <div className="title">{t('LB_BS_WINS')}</div>
        <div className='balance-show'><img src={MonyIconW}/><span className="balanceS">{textFormatAmountFn(pCardPDollar, 0, false)}</span><span className="equal">=</span><img src={MonyIconS}/><span className="balanceW">{textFormatAmountFn(pCardSpendableVal, 0, false)}</span></div>
        {sessionStorage.getItem('enableEwinLP') === '1' && (
            <>
                <div className="desc">
                    {(!qrCodeGenerateFailed || countdown !== 0 ) && t('LB_BS_WINS_QR_DESC')}
                </div>
                <div className="qr-code-warp">
                    <div className="gen-qr-code qr-code-expired">
                    {qrCodeValue && (
                        <>
                            <QRCodeSVG
                                value={qrCodeValue}
                                size={150}
                                bgColor="transparent"
                            />
                            {countdown === 0 && (
                                    <div className="expired-mask"></div>
                            )}
                        </>
                    )}
                    {qrCodeGenerateFailed && (
                        <>
                            <div className="gen-fail-mask"></div>
                            <GenFailIcon className="gen-fail-svg" />
                            <div className="gen-fail-tips">
                                {t('LB_QR_LOAD_FAILED')}
                            </div>
                        </>
                    )}
                    {!qrCodeValue && !qrCodeGenerateFailed && <Loading className="qr-code-loading" />}
                    </div>
                </div>
                {countdown > 0 && !qrCodeGenerateFailed ? (
                    <div className="title">
                        {t('LB_QR_EXPIRE_MESSAGE').replace('{countdown}', countdown)}
                    </div>
                ) : (
                    <div className={`refresh-button ${(!qrCodeValue && !qrCodeGenerateFailed)? 'is-loading' : ''}`} onClick={refreshQRCode}>
                        <span>{t('LB_REFRESH')}</span>
                        <RefIcon/>
                    </div>
                )}
            </>
        )}
    </div>
}
export const LoginAccountInfo = ({
    pwd,
    loginAccount,
    onInputPwd,
    onInputLoginAccount,
    onClickOverlay,
    handleClickSignIn,
    loginInputFocus,
    loginInputBlur,
    isPwdReadOnly,
    isUsernameReadOnly,
    APILoading,
}) => {
    const { t } = useTranslation();
    const disabledLogin =  APILoading;
    return (
        <>
            <div className="account-password-content">
                <input
                    type="text"
                    id="login-account-input"
                    className={`login-account-input ${isUsernameReadOnly ? 'readonly' : ''}`}
                    value={loginAccount}
                    onInput={onInputLoginAccount}
                    onFocus={(e) => {
                        loginInputFocus(e, 'login-account-input');
                    }}
                    onBlur={(e) => {
                        loginInputBlur('login-account-input');
                    }}
                    placeholder={t('LB_BS_LOGIN_ACCOUNT_PLACEHOLDER')}
                    maxLength={15}
                    readOnly={isUsernameReadOnly || disabledLogin}
                />
                <input
                    type="password"
                    id="login-password-input"
                    className={`${pwd?.length > 0 ? 'login-account-pwinput' : ''} ${isPwdReadOnly ? 'readonly' : ''}`}
                    value={pwd}
                    onInput={onInputPwd}
                    onFocus={(e) => {
                        loginInputFocus(e, 'login-password-input');
                    }}
                    onBlur={() => {
                        loginInputBlur('login-password-input');
                    }}
                    placeholder={t('LB_BS_LOGIN_PASSWORD_PLACEHOLDER')}
                    maxLength={20}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && !disabledLogin) {
                            handleClickSignIn();
                        }
                    }}
                    readOnly={isPwdReadOnly || disabledLogin}
                />
              
            </div>
            <div
                className={`signIn cta_yellow ${disabledLogin ? 'disabled' : ''}`}
                onClick={() => !disabledLogin && handleClickSignIn()}
            >
                {isUsernameReadOnly ? t('LB_NEXT') : t('LB_SIGNIN')}
            </div>
            <div className="loginCloseArea">
                <button className="switch-btn-icon open-btn-icon" onClick={onClickOverlay}></button>
            </div>
        </>
    );
};

export const UserInfo = ({ onClickOverlay, handleClickLogout, userInfo, balance, isPcardUser, refreshBalance }) => {
    const { t, i18n } = useTranslation();
    const globalContext = useContext(GlobalContext);
    const lang = i18n.language;
    const [isShowEyeIcon, setIsShowEyeIcon] = useState(true);
    const [isActiveStateBtn, setIsActiveStateBtn] = useState(true);
    const updateNotes = useUpdateRNotes();
    const [showWINSBalance, setShowWINSBalance] = useState(false);
    const [winsBalActiveStateBtn, setWinBalActiveStateBtn] = useState(true);
    const { sendAdobeEvent } = useAdobeLaunch();

    // for racing notes render
    useEffect(() => {
        if (isLogonHigh()) {
            globalContext.racingNotesData.loadNotesData();
        }
    }, [
        isLogonHigh(),
        updateNotes,
        globalContext.racingNotesData.globalEnable,
        globalContext.racingNotesData.settingEnable
    ]);

    useEffect(() => {
        if (Cookies.getData('isMaskAmount') != undefined || Cookies.getData('isMaskAmount') != null) {
            let isMaskAmount = Cookies.getData('isMaskAmount') === 'false' ? false : true;
            setIsShowEyeIcon(isMaskAmount);
        } else {
            Cookies.setData('isMaskAmount', true);
        }

        return () => {
            MaxOnePopupWindow(true);
            if (window.popupWindow && !window.popupWindow.closed) {
                window.popupWindow.close();
            }
        };
    }, []);

    const maxLengthName = (text) => {
        if (!text) return '';
        let newText = text;
        if (text.length > 14) {
            newText = text.slice(0, 12) + '...';
        }
        return newText;
    };

    const changeEyeIcon = () => {
        Cookies.setData('isMaskAmount', !isShowEyeIcon);
        setIsShowEyeIcon(!isShowEyeIcon);
    };

    const balanceAmount = (text) => {
        if (!text) return '---';
        let newText = text;
        if (!isShowEyeIcon) {
            newText = '*****';
        }
        if (text === '...') {
            newText = '---';
        }
        return newText;
    };

    const onClickRefreshBalance = () => {
        if (!isActiveStateBtn) {
            return;
        }
        refreshBalance();
        setIsActiveStateBtn(false);
        setTimeout(() => {
            setIsActiveStateBtn(true);
        }, 3000);
    };

    let betAccount = '';
    let betName = '';

    if (userInfo?.bettingProfile) {
        let langType = lang === 'en' ? 'En' : 'ZhHk';
        const { bettingProfile } = userInfo;
        betAccount = bettingProfile.personalInfo.bettingAccountNumber;

        if (lang === 'en') {
            betName = bettingProfile.personalInfo.firstNameEn + ' ' + bettingProfile.personalInfo.lastNameEn;
        } else {
            betName = bettingProfile.personalInfo.lastNameZhHk + bettingProfile.personalInfo.firstNameZhHk;
        }
    }

    const showUserAvatar = () => {
        let imgUrl = generalImg;

        if(window.globalConfig.show_WINS_Balance && sessionStorage.getItem('enableWinPoints')==='1' && (globalContext?.globalState?.commonCtrl?.WhitelistedCustomerOnlyButton !== true || sessionStorage.getItem('earn_and_burn_pilot') === 'Y')) {
            const pCardTier = sessionStorage.getItem('PCardTier');
            if (pCardTier) {
                switch (pCardTier) {
                    case '1': //red
                        imgUrl = card_red_img;
                        break;
                    case '2': //sliver
                        imgUrl = card_sliver_img;
                        break;
                    case '3': //gold
                        imgUrl = card_gold_img;
                        break;
                    case '4': //black
                        imgUrl = card_black_img;
                        break;
                    case '6': //yellow
                        imgUrl = card_yellow_img;
                        break;
                    default:
                        break;
                }
            }
        }
        return imgUrl;
    };

    const onClickPCard = async () => {
        if(window.globalConfig.show_WINS_Balance === false) return;
        if(sessionStorage.getItem('enableWinPoints')!=='1') return;
        if ( !isPcardUser() ) return;
        if (globalContext?.globalState?.commonCtrl?.WhitelistedCustomerOnlyButton === true && sessionStorage.getItem('earn_and_burn_pilot') !== 'Y') return;

        if (!winsBalActiveStateBtn) {
            if (sessionStorage.getItem('pCardSpendableVal') != null) {
                setShowWINSBalance(true);
            }
        } else {
            const pOut = await getPCardBalance_IB();

            if (pOut.success) {
                if(sessionStorage.getItem('enableEwinLP')==='1') {
                    sendAdobeEvent({ event: 'interaction', interaction: { eventID: 'eWin_Betslip_DisplayHKJCPriorityQR' } });
                }
                setShowWINSBalance(true);
                setWinBalActiveStateBtn(false);
                setTimeout(() => {
                    setWinBalActiveStateBtn(true);
                }, 5000);
            }
        }
    };

    return (
        <>
            <div className="betslip-account df">
                <div className="betslip-pcard" onClick={onClickPCard}>
                    <img src={showUserAvatar()} alt="personal img" className="betslip-pcard-img" />
                    {showWINSBalance && (
                        <WINSBalance setShowWINSBalance={setShowWINSBalance} showWINSBalance={showWINSBalance} />
                    )}
                </div>
                <div>
                    <div className="marginB2">
                        <div className="lineH13 marginB1">{t('LB_BS_LOGIN_ACCOUNT')}</div>
                        <div className="fontS15 lineH18">{betAccount}</div>
                    </div>
                    <div className="df lineH13 marginB1">
                        <div className="">{t('LB_BS_LOGIN_BALANCE')}</div>
                        <div
                            className={`${isShowEyeIcon ? 'eyeOn-icon' : 'eyeClose-icon'}`}
                            onClick={changeEyeIcon}
                        ></div>
                    </div>
                    <div className="df userAmount" style={{ alignItems: 'center' }}>
                        <div className={`${String(balanceAmount(balance)).length > 12 ? 'fontS14' : 'fontS15'} lineH18`}>$ {balanceAmount(balance)}</div>
                        <div className={`refresh-icon ${isActiveStateBtn ? '':'rotate'}`} onClick={onClickRefreshBalance}></div>
                    </div>
                </div>
            </div>
            <div className={`loginCloseAreaCon ${isPcardUser() ? 'pcardClose' : ''}`}>
                <div className="loginCloseArea">
                    <button className="switch-btn-icon open-btn-icon" onClick={onClickOverlay}></button>
                    {}
                </div>
                <div className="logout signIn" onClick={handleClickLogout}>
                    {t('LB_LOGOUT')}
                </div>
            </div>
        </>
    );
};

export const LogoutReminder = ({ showReminder, onCancel, onConfirm, isShowLogoutBetText }) => {
    const { t } = useTranslation();
    const getReminderMessage = () => {
        if (isShowLogoutBetText) {
            return t('LB_BS_LOGIN_FORGOT_ANSWER_MSG');
        }
        if (window.globalConfig.RETAIN_BETS_IN_BET_SLIP_ON_LOGOUT) {
            return t('NEW_LB_BS_LOGOUT_REMINDER');
        }
        return t('LB_BS_LOGOUT_REMINDER');
    };

    return (
        <Popup open={showReminder} className="logout-reminder" closeOnDocumentClick={false}>
            <div className="logout-reminder-container">
                <div className="title">bet.hkjc.com says</div>
                <div className="logout-reminder-message">
                    {getReminderMessage()}
                </div>
                <div className="button-box">
                    <div onClick={onCancel}>{t('LB_BS_LOGIN_CANCEL')}</div>
                    <div id="betlogoutbox-home-box" onClick={onConfirm}>
                        {t('LB_BS_LOGIN_OK')}
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export const LogoutSuccessMsg = ({ showMsg = false }) => {
    const { t, i18n } = useTranslation();
    const [msgOpen, setMsgOpen] = useState(true);
    const [logoutDateTime, setLogoutDateTime] = useState(null);
    const { msgLoading, loadLogoutBox, textEnable, text, imageEnable, image } = useLogoutBoxQuery();

    const { sendAdobeEvent } = useAdobeLaunch();

    useEffect(() => {
        if (showMsg) {
            setLogoutDateTime(moment().format('HH:mm DD-MM-YYYY'));
            setMsgOpen(true);
            loadLogoutBox();
        }
    }, [showMsg]);

    const onClickClose = () => {        
        sendAdobeEvent({ event: 'interaction', interaction: { eventID: 'betlogoutbox-home-button-close' } });

        glassboxCustomEvent('Logout_Close_button');
        setMsgOpen(false);
        sessionStorage.removeItem('customerSegment');
        sessionStorage.removeItem('hWebID');
        sessionStorage.removeItem('customerHash');
    };

    return !msgLoading ? (
        <Popup
            open={msgOpen && (textEnable || imageEnable)}
            closeOnDocumentClick={false}
            className="logout-succ-msg logout-succ-msg-m"
        >
            <div className="logout-succ-msg-container">
                <div>{t('LB_BS_LOGOUT_SUCCESS_MSG')}</div>
                <div>
                    {t('LB_BS_LOGOUT_SUCCESS_TIME')} {logoutDateTime}
                </div>
                <div className="succ-msg-content">
                    <div className="message-box">{textEnable ? text : ''}</div>
                    {imageEnable && image && (
                        <div className="banner-box">
                            <div>
                                <img src={getSiteCoreImagePath(image.src, i18n.language)} title={image.alt} />
                            </div>
                        </div>
                    )}
                </div>
                <div className="close-btn-box">
                    <div id="betlogoutbox-home-button-close" className="close" onClick={onClickClose}>
                        {t('LB_CLOSE')}
                    </div>
                </div>
            </div>
        </Popup>
    ) : null;
};

export const LoginIncorrect = ({ messageCode, onClose, showClose = true, setShowLoginLockPopup }) => {
    const [message, setMessage] = useState('');
    const { t, i18n } = useTranslation();
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    useEffect(() => {
        if (messageCode) {
            var errMsg;
            switch (messageCode) {
                // case 'CIAM_100002':
                //     errMsg = '423';
                //     setShowLoginLockPopup(true);
                //     break;
                case 415:
                case 416:
                    errMsg = t('LB_BS_LOGIN_ERROR_OTHER') + ` (${messageCode})`;
                    break;
                default:
                    if(typeof messageCode === "object" && messageCode?.[i18n.language]) {
                        errMsg = messageCode[i18n.language]
                    } else {
                        errMsg = t('LB_BS_LOGIN_ERROR_' + messageCode);
                        //Cannout found in json, display code directly
                        if (errMsg.indexOf('LB_BS_LOGIN_ERROR') >= 0) {
                            errMsg = messageCode;
                        }
                    }
                    
                    break;
            }

            setMessage(errMsg);
        } else {
            setMessage('');
        }
    }, [messageCode, i18n.language]);

    return (
        <>
            {
                message ? (
                    <div className="login-incorrect-message-container">
                        {showClose && <div onClick={onClose} className="switch-btn-icon open-btn-icon"></div>}
                        <div dangerouslySetInnerHTML={{ __html: message }}></div>
                    </div>
                ) : (
                    <></>
                ) //<LoginErrorPopup errorType={message} handleClickCancel={onClose} setShowErrorPopup={setShowErrorPopup}/>
            }
        </>
    );
};

export const ApiErrPopupUI = ({ isApiErr, errorMessageCode }) => {
    const { t } = useTranslation();
    let errorMessage = '';
    if(errorMessageCode == "-3") {
        errorMessage = t('ACCOUNT_STATEMENT_ERROR_-3');
    } else {
        errorMessage = t('LB_BS_NET_ERROR') + '(' + errorMessageCode + ')';
    }
    
    return (
        <Popup open={isApiErr} className="logout-reminder cashout-reminder" closeOnDocumentClick={false}>
            <div className="cashout-reminder-container">
                <div className="cashout-reminder-message">
                    {errorMessageCode ? errorMessage : t('LB_BS_NET_ERROR')}
                </div>
                <div className="button-box">
                    <div
                        className="cancelBtn confirmBtn"
                        onClick={() => {
                            window.close();
                        }}
                    >
                        {t('LB_BS_FT_CONFIRM')}
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export const setTokenToSession = (token) => {
    window.sessionStorage.setItem('access_token', token.accessToken);
    window.sessionStorage.setItem('refresh_token', token.refreshToken);
    window.sessionStorage.setItem('id_token', token.idToken);
    token.login_account && window.sessionStorage.setItem('login_account', token.login_account);
};

export const setCustomerProfileDataFromTokens = (accessToken, idToken) => {
    const iterateFunc = (arr, name) => {
        if(arr && Array.isArray(arr)){
            let returnStr = ""
            arr.forEach((element, id) => {
                if(name == "o2oSegments"){
                    if(element.value){
                        if(element.value.length==1){
                            returnStr += " "+element.validateFunc
                        }else if(element.value.length==2){
                            returnStr += element.validateFunc
                        }else{
                            returnStr+="**"
                        }
                    }else{
                        returnStr+="  "
                    }
                }else{
                    if(id==0)
                        returnStr += element
                    else
                        returnStr += "#" + element
                }
            })
            return returnStr
        }
        return ""
    }
    const accessTokenObj = jwtDecode(accessToken);
    const idTokenObj = jwtDecode(idToken);

    console.debug(accessTokenObj);
    console.debug(idTokenObj);

    let marketingSegments = iterateFunc(idTokenObj.o2oSegments, "o2oSegments");

    sessionStorage.setItem("displayName", "");
    sessionStorage.setItem("salutation", idTokenObj.sw?idTokenObj.sw:idTokenObj.scw);
    sessionStorage.setItem("lastNameEn", idTokenObj.lnw);
    sessionStorage.setItem("lastNameZh", idTokenObj.lncw);
    sessionStorage.setItem("sMarketingSegments", marketingSegments);
    sessionStorage.setItem("webID", accessTokenObj.webId);
    sessionStorage.setItem("hWebID", accessTokenObj.externalGUID);
    sessionStorage.setItem("priority_card", idTokenObj.isPriorityCardHolder ? "Y" : "N");
    // call getPCardBalance_IB instead
    // sessionStorage.setItem("PCardTier", idTokenObj.isPriorityCardHolder ? idTokenObj.priorityCardTierCode : "");
    sessionStorage.setItem("cbp_seg", idTokenObj.cbpSegment);
    sessionStorage.setItem("racing_part", idTokenObj.isRacingParticipant ? "Y" : "N");
    sessionStorage.setItem("football_part", idTokenObj.isFootballParticipant ? "Y" : "N");
    sessionStorage.setItem("m6_part", idTokenObj.isM6Participant ? "Y" : "N");

    sessionStorage.setItem("member_type", accessTokenObj.hkjcCardCategoryCode);

    sessionStorage.setItem("age_group", idTokenObj.agw<10?'0'+idTokenObj.agw:idTokenObj.agw);
    sessionStorage.setItem("gender", idTokenObj.gcw);
    // betting_ac_ind missing in CIAM, but assume always Y from eWin
    sessionStorage.setItem("betting_ac_ind", "Y");
    sessionStorage.setItem("speedbet_cust", idTokenObj.hasSpeedbet ? "Y" : "N");
    sessionStorage.setItem("football_live_ind", idTokenObj.hasWebTv ? "Y" : "N");
    sessionStorage.setItem("have_webcast_access", idTokenObj.hasWebcast ? "Y" : "N"); 
    sessionStorage.setItem("earn_and_burn_pilot", idTokenObj.o2oSegments?.some(s => s.name === "EarnAndBurnPilot") ? "Y" : "N");
    setCustomerSegment();
}

export const setCustomerSegment = () => {
    const validateFunc = (item, defaultVal, isString=false) => {
        if(isString)
                return item&&item!='undefined'&&item!='null'?item:defaultVal;
        return /^[YN\d]+$/.test(item)? item : defaultVal;
    };

    const displayName = validateFunc(sessionStorage.getItem('displayName'), '', true);
    const salutation = validateFunc(sessionStorage.getItem('salutation'), '', true);
    const lastNameEn = validateFunc(sessionStorage.getItem('lastNameEn'), '', true);
    const lastNameZh = validateFunc(sessionStorage.getItem('lastNameZh'), '', true);
    const slogan = validateFunc(sessionStorage.getItem('slogan'), '', true);
    const sMarketingSegments = validateFunc(sessionStorage.getItem('sMarketingSegments'), '', true);
    const priority = validateFunc(sessionStorage.getItem('priority_card'), '0');
    let cbp = validateFunc(sessionStorage.getItem('cbp_seg'), '00000');
    if (cbp.length < 5) {
        cbp = new Array(6 - cbp.length).join('0') + cbp;
    }
    const racing = validateFunc(sessionStorage.getItem('racing_part'), 'N');
    const football = validateFunc(sessionStorage.getItem('football_part'), 'N');
    const marksix = validateFunc(sessionStorage.getItem('m6_part'), 'N');
    const member = validateFunc(sessionStorage.getItem('member_type'), '0');
    const ageGroup = validateFunc(sessionStorage.getItem('age_group'), '00');
    const gender = validateFunc(sessionStorage.getItem('gender'), '0');
    const bettingAC = validateFunc(sessionStorage.getItem('betting_ac_ind'), 'N');
    const myLoginLanugage = validateFunc(sessionStorage.getItem('sLanguage'), '0');
    const speedbet = validateFunc(sessionStorage.getItem('speedbet_cust'), '0');
    const footballLive = validateFunc(sessionStorage.getItem('football_live_ind'), 'N');
    
    const customerSegment =
        priority + cbp + racing + football + marksix + member + ageGroup + gender + bettingAC + myLoginLanugage + speedbet + footballLive;

    const favHorse = validateFunc(sessionStorage.getItem('favHorse'), '', true);
    const favTrainers = validateFunc(sessionStorage.getItem('favTrainers'), '', true);
    const favTeams = validateFunc(sessionStorage.getItem('favTeams'), '', true);
    const favJockeys = validateFunc(sessionStorage.getItem('favJockeys'), '', true);

    const hWebID = validateFunc(sessionStorage.getItem('hWebID'), '', true);

    sessionStorage.setItem('customerSegment', customerSegment);
    sessionStorage.setItem('customerHash', hWebID);
    sessionStorage.setItem('webTV', footballLive == 'Y');

    const expires = new Date(new Date().getTime() + 60 * 60 * 1000).toUTCString();
    document.cookie = `custProInBet=%3A%3A%3A%3A%3A%3A${customerSegment}%3A;expires=${expires};domain=${window.domainName};path=/`;

    const cookieValue = `${displayName}:${salutation}:${lastNameEn}:${lastNameZh}:${slogan}:${sMarketingSegments}:${customerSegment}:${favTeams}:${favHorse}:${favTrainers}:${favJockeys}:${hWebID}`
    sessionStorage.setItem('custProIn', cookieValue);
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');
    const mainDomain = domainParts.slice(-2).join('.'); 
    JSCookies.set('custProIn', cookieValue, { expires: 7, domain: mainDomain })
};